import { useGetGroups as useGetArtemyGroups } from '@vlabs/api/artemy/client';
import { useGetGroups } from '@vlabs/api/luna-api/client';
import { Tag } from '@vlabs/uikit/components/tag';

import st from './shared.module.sass';

interface GroupCellProps {
  permissionTag: string;
}

function GroupCell({
  permissionTag,
}: GroupCellProps): JSX.Element | null {
  const { data: groupsDetails } = useGetArtemyGroups({ permission_tags: [permissionTag] });

  const groupsId = (groupsDetails?.groups ?? [])
    .map((group) => group.group_id)
    .filter((id): id is string => Boolean(id));

  const { data: groups } = useGetGroups(
    { group_ids: groupsId },
    { query: { enabled: groupsId.length > 0 } },
  );

  if (!groupsId.length) return null;

  return (
    <div className={st.GroupCell}>
      {groupsId.map((groupId) => {
        const group = groups?.groups?.find(
          (item) => item.group_id === groupId,
        );

        return (
          <Tag
            key={group?.group_name ?? groupId}
            kind="neutral"
            shape="square"
            size="large"
            value={group?.group_name ?? groupId}
          />
        );
      })}
    </div>
  );
}

export { GroupCell };
